import React, { useContext } from "react"
import { useDrop } from "react-dnd"
import { T配車, T車輌乗務員 } from "../../../../service/order/haisya/THaisya"
import { ItemType } from "../HaisyaRegister"
import {
  CalenderSearchContext,
  MihaisyaListContext,
  MihaisyaSearchContext,
  SearchConditionContext,
  ZyomuinListContext,
} from "../HaisyaContext"
import { useDispatch, useSelector } from "react-redux"
import { AppDispatch } from "../../../.."
import { set配送順 } from "../haisyaRegisterUtil"
import dayjs from "dayjs"
import { RootState } from "../../../../globalStore/rootreducer"
import { showWarningToast } from "../../../../components/CustomToast"

const HaisyaTableCell: React.FC<{
  haisoNo: number
  date: string
  zyomuin: T車輌乗務員
  className?: string
  onClick?: React.MouseEventHandler<HTMLDivElement>
  onContextMenu?: React.MouseEventHandler<HTMLDivElement>
  onDoubleClick?: React.MouseEventHandler<HTMLDivElement>
}> = (props) => {
  const { 車輌乗務員List, set車輌乗務員List } = useContext(ZyomuinListContext)
  const 営業日 = useSelector((state: RootState) => state.date.eigyobiStr)
  const { set未配車List } = useContext(MihaisyaListContext)
  const searchCondition = useContext(SearchConditionContext)
  const dispatch: AppDispatch = useDispatch()
  const calenderSearch = useContext(CalenderSearchContext)
  const mihaisyaSearch = useContext(MihaisyaSearchContext)

  const [, dropRef] = useDrop(
    () => ({
      accept: ItemType.配車日単位,
      drop: async (item: { 積日?: string; 受注配車: T配車 }, monitor) => {
        // 前日以前の日付のセルにはドロップできない
        const セル積日 = dayjs(props.date)

        if (
          !セル積日.isSame(dayjs(営業日), "d") &&
          セル積日.isBefore(dayjs(営業日), "d")
        ) {
          showWarningToast("営業日以前の運行は登録できません。")
          return
        }

        // 同一日付内で同一車輌同一乗務員のドロップの場合処理を行わない
        if (item.積日) {
          const isSameTumiDate = dayjs(item.積日).isSame(
            dayjs(props.date),
            "date"
          )
          if (
            props.zyomuin.乗務員ID === item.受注配車.乗務員ID &&
            props.zyomuin.車輌ID === item.受注配車.車輌ID &&
            isSameTumiDate
          )
            return
        }

        const res = await set配送順({
          dispatch,
          searchCondition,
          set未配車List,
          set車輌乗務員List,
          乗務員: props.zyomuin,
          積日: props.date,
          配車: item.受注配車,
          配送順: props.haisoNo,
        })
        if (res) {
          await calenderSearch()
          await mihaisyaSearch()
        }
      },
    }),
    [車輌乗務員List]
  )
  return (
    <td className={props.className} ref={dropRef}>
      <div
        onClick={props.onClick}
        onContextMenu={props.onContextMenu}
        onDoubleClick={props.onDoubleClick}
        className="w-100 h-100">
        {props.children}
      </div>
    </td>
  )
}

export default HaisyaTableCell
